/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';

const DateSelector = ({ onClick, value }) => {
  return (
    <button
      type="button"
      className="date-selector"
      onClick={onClick}
    >
      {value}
      <i className="caret caret-down" />
    </button>
  );
};

DateSelector.PropTypes = {
  onClick: PropTypes.func,
  value: PropTypes.string,
};

export default DateSelector;



// WEBPACK FOOTER //
// ./components/calendar-header/date-selector/index.js